import React from 'react';
import { IoDuplicateOutline } from 'react-icons/io5';
import { Button } from 'react-bootstrap';
import { UseAsyncReturn } from 'react-async-hook';
import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import { DealerWithFlags } from '@upstart/harmony/lib/legos/dealerTypes';
import {
  isCounter,
  isDenied,
  isResponseEditable,
} from '@upstart/harmony/lib/response-utils';
import LoadingOverlay from '../../../components/LoadingOverlay';

import './DuplicateOfferButton.scss';

type Props = {
  dealer: DealerWithFlags;
  financeResponse: FinanceResponse;
  isUpstartOffer: boolean;
  isInvalid: boolean;
  disabled?: boolean;
  asyncCloneFinanceResponse: UseAsyncReturn<FinanceResponse, any[]>;
  forceExpandOfferList: () => void;
  amplitudeOnclickAction?: () => void;
};

const DuplicateUpstartOfferButton = ({
  dealer,
  financeResponse,
  isUpstartOffer,
  isInvalid,
  disabled,
  asyncCloneFinanceResponse,
  forceExpandOfferList,
  amplitudeOnclickAction,
}: Props) => {
  if (!dealer.flags.isUpstartCloneOfferEnabled) {
    return null;
  }

  if (!isUpstartOffer) {
    return null;
  }

  const onBtnClick = async () => {
    if (amplitudeOnclickAction) {
      amplitudeOnclickAction();
    }
    await asyncCloneFinanceResponse.execute(financeResponse.id);
    forceExpandOfferList(); // expand offer list
  };

  const disableDuplicateButton =
    disabled ||
    isDenied(financeResponse) ||
    isCounter(financeResponse) ||
    isInvalid ||
    !isResponseEditable(financeResponse);

  return (
    <LoadingOverlay active={asyncCloneFinanceResponse.loading} size={'tiny'}>
      <Button
        bsClass="btn btn-link duplicate-offer-button"
        data-testid="duplicate-offer-button"
        disabled={asyncCloneFinanceResponse.loading || disableDuplicateButton}
        onClick={onBtnClick}
      >
        <span>
          <IoDuplicateOutline />
          {'Create Duplicate'}
        </span>
      </Button>
    </LoadingOverlay>
  );
};

export default DuplicateUpstartOfferButton;
